"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Keyboard_1 = require("../../../_Core/Keyboard");
var Icons_1 = require("../../../Icons");
var Localization_1 = require("../../../Localization");
var SearchableNestedDropdown_context_1 = require("../SearchableNestedDropdown.context");
var Header_styles_1 = require("./Header.styles");
exports.default = React.forwardRef(function (_a, ref) {
    var _b = React.useContext(SearchableNestedDropdown_context_1.SndContext), Parent = _b.Parent, SelectParent = _b.SelectParent, ClearControl = _b.ClearControl, Items = _b.Items;
    var Caption = Parent.Caption;
    var backButtonRef = React.createRef();
    React.useImperativeHandle(ref, function () { return ({
        focusHeaderControl: function () {
            backButtonRef.current.focus();
        },
    }); });
    React.useEffect(function () {
        if (!Items || (Items && Items.length === 0)) {
            backButtonRef.current.focus();
        }
    }, [Items]);
    var handleOnFolderBackClick = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        SelectParent(Parent);
    };
    var handleOnKeyUp = function (e) {
        if (Keyboard_1.IsEnter(e)) {
            e.nativeEvent.stopImmediatePropagation();
            SelectParent(Parent);
        }
    };
    var handleOnFolderClearClick = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        ClearControl();
    };
    return (React.createElement(Header_styles_1.OpenHeader, null,
        React.createElement(Header_styles_1.ClickableWrapper, { "aria-label": Localization_1.strings.SND_Action_BackToParent, onClick: handleOnFolderBackClick, onKeyUp: handleOnKeyUp, ref: backButtonRef, role: "button", tabIndex: 0, title: Localization_1.strings.SND_Label_BackToParent },
            React.createElement(Icons_1.ChevronLeftIcon, null),
            React.createElement(Header_styles_1.FolderText, null, Caption)),
        React.createElement(Header_styles_1.HeaderButton, { "aria-label": Localization_1.strings.SND_Action_Close, onClick: handleOnFolderClearClick, title: Localization_1.strings.SND_Label_Close, type: "button" },
            React.createElement(Icons_1.CloseThinIcon, null))));
});
